var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"modal-check"},[_c('md-checkbox',{staticClass:"md-primary",on:{"change":function($event){return _vm.$emit('option', _vm.check)}},model:{value:(_vm.check),callback:function ($$v) {_vm.check=$$v},expression:"check"}},[_c('span',{staticClass:"text-dont-show"},[_vm._v("Don't show this again")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }